module.exports = __webpack_public_path__ + "d8ef4ccf9f68b708028cac86811215a9.fbx";